module.exports = __webpack_public_path__ + "media/images/promo/championship/icon_2-dddca279ee131823badae5a13e09bdbe.png";